import {
    Box,
    Text,
    List,
    ListItem,
    Tag,
    TagLabel,
    TagLeftIcon,
    Tooltip,
    useColorModeValue,
    Divider,
    IconButton
} from "@chakra-ui/react";
import {CheckIcon, DeleteIcon} from "@chakra-ui/icons";
import {useEffect, useState} from "react";
import {getAxiosInstance} from "../../../utils/axiosInstance";
import axios from "axios";
import {toast} from "react-toastify";
import ModalEditProductDetails from "../ModalEditProductDetails";
import {useTranslation} from "react-i18next";
import {Product} from "../product.type";
import DeleteConfirmationModal from "../DeleteConfirmationModal";


const ProductDetails = (props: { productId: string | undefined }) => {
    const [product, setProduct] = useState<Product | null>(null);
    const [editProductDetails, setEditProductDetails] = useState<boolean>(false);
    const [deleteProductModal, setDeleteProductModal] = useState<boolean>(false);
    const {t} = useTranslation("translations");

    const fetchProduct = async () => {
        try {
            const req = await getAxiosInstance().get(`/Products/${props.productId}`);
            setProduct(req.data);
        } catch (error) {
            if (axios.isAxiosError(error)) {
                toast.error(`${error.response?.data}`, {position: toast.POSITION.BOTTOM_RIGHT})
            } else {
                toast.error(`Could not retrieve the product from the database ${error}`, {position: toast.POSITION.BOTTOM_RIGHT});
            }
        }
    }

    useEffect(() => {
        fetchProduct();
    }, [props.productId, editProductDetails])

    return (
        <>
            <Box className="w-[100%] md:w-[45%]">
                <Tooltip label={t("Click to Edit Product Details!")} aria-label='A tooltip' placement='top-start'>
                    <Text
                        onClick={(e) => {
                            setEditProductDetails(true)
                        }}
                        lineHeight={1.1}
                        fontWeight={600}
                        fontSize={{base: '2xl', sm: '4xl', lg: '5xl'}}>
                        {product ? product.name : ""}
                    </Text>
                </Tooltip>

                <Text
                    color={useColorModeValue('gray.500', 'gray.400')}
                    fontSize={'md'}
                    fontWeight={'400'}
                    mb={'6'} mt={"3"}>
                    {product?.description ? product.description : "-"}
                </Text>

                <Text
                    fontSize={{base: '16px', lg: '18px'}}
                    color={'teal'}
                    fontWeight={'500'}
                    textTransform={'uppercase'}
                >
                    <Tooltip label={t("Click to delete product!")} aria-label="delete-product" placement='top-start'>
                        <IconButton
                            colorScheme="red"
                            aria-label="delete-product"
                            className="m-2"
                            onClick={() => setDeleteProductModal(true)}
                        >
                            <DeleteIcon />
                        </IconButton>
                    </Tooltip>
                    {t("Product Details")}
                </Text>

                <Divider opacity={4} mb={'4'}/>

                <List spacing={2} mb={'2'}>
                    <ListItem>
                        <Text as={'span'} fontWeight={'bold'}>
                            {t("Unit of Measurement")}:
                        </Text>{' '}
                        {product ? product.unitMeasurement.name : ""}
                    </ListItem>
                    <ListItem>
                        <Text as={'span'} fontWeight={'bold'}>
                            {t("PRODUCT_WORK_PRICE")}:
                        </Text>{' '}
                        {product && product.productWorkPrice ? product.productWorkPrice : "-"}
                    </ListItem>
                    <ListItem>
                        <Text as={'span'} fontWeight={'bold'}>
                            {t("PRODUCT_PROGRAMING_WORK_PRICE_RATE")}:
                        </Text>{' '}
                        {product && product.productProgramingWorkPrice ? product.productProgramingWorkPrice : "-"}
                    </ListItem>
                    <ListItem>
                        <Text as={'span'} fontWeight={'bold'}>
                            {t("Minimum Quantity")}:
                        </Text>{' '}
                        {product ? product.minQuantity : ""}
                    </ListItem>
                    <ListItem>
                        <Text as={'span'} fontWeight={'bold'} className="mr-2">
                            {t("SKU")}:
                        </Text>
                        {product ? product.sku : ""}
                    </ListItem>
                    <ListItem mb={4}>
                        <Text as={'span'} fontWeight={'bold'}>
                            {t("Categories")}:
                        </Text>
                    </ListItem>
                    <div className="flex flex-wrap">
                        {
                            product?.categories && product.categories.map((c: any, index: number) => {
                                return (
                                    <Tag size='lg' colorScheme='blue' borderRadius='full' className="m-1">
                                        <TagLeftIcon as={CheckIcon}/>
                                        <TagLabel> {c.name} </TagLabel>
                                    </Tag>
                                )
                            })
                        }
                    </div>
                </List>


            </Box>
            {
                product &&
                <ModalEditProductDetails
                    onClose={() => {
                        setEditProductDetails(false)
                        fetchProduct()
                    }}
                    isOpen={editProductDetails}
                    product={product}
                />
            }
            <DeleteConfirmationModal
                id={product?.id}
                isOpen={deleteProductModal}
                onClose={() => setDeleteProductModal(false)}
            />
        </>
    )
}

export default ProductDetails;